import { useEffect, useState } from 'react';

/**
 * Milliseconds until a moment, ticking once a second.
 *
 * Recomputed from the target rather than decremented, so a phone that slept
 * through the last two minutes shows the right number on waking instead of
 * resuming where it left off.
 */
export const useCountdown = (target: Date | null): number => {
    const [remaining, setRemaining] = useState(() =>
        target ? target.getTime() - Date.now() : 0,
    );

    useEffect(() => {
        if (!target) return;
        const tick = (): void => setRemaining(target.getTime() - Date.now());
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [target]);

    return remaining;
};
